import { Stack, Text, rem } from '@mantine/core';
import { IconListSearch } from '@tabler/icons-react';
export default function EmptyListResult({
  message = 'No se han encontrado resultados.'
}: {
  message?: string;
}) {
  return (
    <Stack justify="center" align="center" w={'100%'}>
      <IconListSearch color="gray" style={{ width: rem(80), height: rem(80) }} />
      <Text c="dimmed">{message}</Text>
    </Stack>
  );
}
